export const NO_RATING = 'NR'
